import { faEnvelope, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { InserirEnvelopeController } from "../../../Controllers/Geral/Envelopes/EnvelopesControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { AlertConfirmation } from "../../../Tools/SweetAlerts";
import EnviarEnvelopeModal from "./SelecionarEnvelopeModal";

interface IEnvelopesGeradosProps{

}

export default function EnvelopesGerados(props: IEnvelopesGeradosProps){

    const {ID_CASO} = useAtendimentoPage()

    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const {
        execute: executeInserirEnvelope,
        loading
    } = useAsyncCallback(InserirEnvelopeController)

    function handleGerarEnvelope() {
        executeInserirEnvelope({ID_CASO: ID_CASO}).then((response) => {
            if (response.LST_ENVELOPES?.length > 1) {
                setShow(true);
                setModal({
                    Component: () => <EnviarEnvelopeModal setModal={setModal} envelopes={response} setShow={setShow} />,
                    headerComponent: 'Envio de Envelopes',
                    IconHeader: faEnvelope
                });    
            }

        })
    }

    return (
        <div className="card card-custom py-2">
            <div className="d-flex justify-content-end">
                {
                    <button className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap ml-3 mr-3 g-2 m-3"
                        disabled={loading}
                        onClick={() => {
                                AlertConfirmation("Confirmar Envio do Envelope?", "", undefined, {cancelButtonText: "Não", confirmButtonText: "Sim"}).then((response) => {
                                    if(response.isConfirmed) {
                                        handleGerarEnvelope()
                                    }
                                })
                    }}>
                        
                        <span>
                            {loading ? (
                                <span>
                                    <Spinner size="sm" /> Gerar Envelope
                                </span>
                            ) : (
                                <span>
                                    {" "}
                                    <FontAwesomeIcon icon={faPlus} /> Gerar
                                    Envelope
                                </span>
                            )}
                        </span>
                    </button>
                }
            </div>
            <ModalComponent show={show} setShow={setShow} ModalComponent={modal} />
        </div>
    )
}